export default {"src":"/_next/static/media/tiktok.6d4b3e9a.svg","height":32,"width":33};